import React, {useState} from 'react';

import ExtractByTypename from 'graphql-client/ExtractByTypename';
import {GetAnalyticsDashboard} from 'insights/analytics-dashboards/details/graphql/__generated/GetAnalyticsDashboard';
import {convertGQLToRESTAnalyticsQuery} from 'insights/analytics-queries/data/AnalyticsQueryGQLRESTConverters';
import {AnalyticsQuerySpecRequest} from 'insights/analytics-queries/RESTAnalyticsQueryTypes';
import AnalyticsDescriptionEditor from 'insights/AnalyticsDescriptionEditor';
import Col from 'ui-library/bs/Col';
import FormGroup from 'ui-library/bs/FormGroup';
import Row from 'ui-library/bs/Row';
import {ButtonStyle} from 'ui-library/buttons/Button';
import useFormInput from 'ui-library/hooks/useFormInput';
import FieldLabel from 'ui-library/inputs/FieldLabel';
import TextField from 'ui-library/inputs/TextField';
import Modal from 'ui-library/modals/Modal';

type AnalyticsQuery = ExtractByTypename<
  GetAnalyticsDashboard['analyticsDashboard'],
  'AnalyticsDashboardNode'
>['analyticsQueries'][number];

interface Actions {
  updateAnalyticsQuery: (analyticsQuery: string, querySpecRequest: AnalyticsQuerySpecRequest) => void;
}

export interface AnalyticsQuerySettingsModalProps {
  actions: Actions;
  analyticsQuery: AnalyticsQuery;
  onRequestClose: () => void;
  onRequestSubmit: () => void;
}

export default function AnalyticsQuerySettingsModal(props: AnalyticsQuerySettingsModalProps): JSX.Element {
  const [description, setDescription] = useState<string>(props.analyticsQuery.description);
  const nameFormInput = useFormInput(props.analyticsQuery.name);

  function handleSubmit(): void {
    const querySpecRequest = {
      ...convertGQLToRESTAnalyticsQuery(props.analyticsQuery),
      description,
      name: nameFormInput.value,
    };
    props.actions.updateAnalyticsQuery(props.analyticsQuery.id, querySpecRequest);
    props.onRequestSubmit();
  }

  return (
    <Modal
      buttons={[{style: ButtonStyle.SECONDARY, submit: true, text: 'Save'}]}
      onRequestClose={props.onRequestClose}
      onRequestSubmit={handleSubmit}
      title="Block settings"
    >
      <FormGroup>
        <Row>
          <Col sm={12}>
            <TextField label="Name" {...nameFormInput} />
          </Col>
        </Row>
      </FormGroup>
      <Row>
        <Col sm={12}>
          <FormGroup>
            <FieldLabel label="Description" />
            <AnalyticsDescriptionEditor setDescription={setDescription} description={description} />
          </FormGroup>
        </Col>
      </Row>
    </Modal>
  );
}
